import { useEffect } from 'react';

import { scroller } from 'react-scroll';

export const useScrollToEndOfMessages = ({
  messages,
  elementId,
  containerId,
}: {
  messages: Array<any>;
  elementId: string;
  containerId?: string;
}) => {
  useEffect(() => {
    scroller.scrollTo(elementId, {
      smooth: true,
      containerId,
    });
  }, [messages.length]);
};
